'use es6';

import { combineReducers } from 'redux';
import allCollections from './allCollections';
import auth from './auth';
import appIntegrations from './appIntegrations';
import details from './details';
import requestStates from './requestStates';
import reviews from './reviews';
import notifications from 'ReduxMessenger/reducers/Notifications';
import trackingParams from './trackingParams';
import users from './users';
import featuredCallouts from './featuredCallouts';
import collections from './collections';
export default combineReducers({
  allCollections,
  auth,
  appIntegrations,
  collections,
  details,
  featuredCallouts,
  notifications,
  requestStates,
  reviews,
  trackingParams,
  users
});